import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ButtonBox from "Shared/ButtonBox";
import { SecondaryLink } from "Shared/Buttons";
import styled from "styled-components";
import ArrowLeftIcon from "src/components/icons/ArrowLeft";
import VinNumber from "src/components/VinNumber/VinNumber";
import { Appointment } from "Types/api/Appointment";
import { VehicleState } from "Types/state";
import { getAppointmentTimeToDisplay } from "../ScheduleAppointment/lib";
import insuranceImage from "./carinsurance.png";
import dlImage from "./dl.png";
import "./ScheduleAppointmentSuccess.scss";
import titleImage from "./title.png";

const ArrowLeft = styled(ArrowLeftIcon)`
    color: ${(props) => props.theme.palette.primary.main};
    height: 0.8em;
`;

export interface ScheduleAppointmentSuccessProps {
    account: any;
    appointmentDate: string;
    appointmentTime: Appointment["time"];
    hasTradePending?: boolean;
    tradePendingBalance?: number;
    vehicle: VehicleState;
}

class ScheduleAppointmentSuccess extends Component<ScheduleAppointmentSuccessProps & WithTranslation> {
    public render() {
        const vehicle = this.props.vehicle;
        const {
            address: { street, city, state, zip, country },
            phone,
        } = this.props.account;
        const { hasTradePending, tradePendingBalance, t } = this.props;

        const fullAddress = `${street}+${city}+${state}+${zip}+${country}`.replace(" ", "+");

        return (
            <div className="ScheduleAppointmentSuccess">
                <h1>{t("ContinueDeal.ScheduleAppointmentSuccess.title")}</h1>
                <div>
                    {t("ContinueDeal.ScheduleAppointmentSuccess.subtitle")}{" "}
                    <strong>
                        {this.props.appointmentDate} {getAppointmentTimeToDisplay(this.props.appointmentTime)}.
                    </strong>
                    <div className="ScheduleAppointmentSuccess__details">
                        <div className="ScheduleAppointmentSuccess__image--container">
                            <img className="ScheduleAppointmentSuccess__image" src={vehicle.thumbnail} alt="" />
                        </div>
                        <div className="ScheduleAppointmentSuccess__vehicle-title">
                            {vehicle.title}
                            <br />
                            <VinNumber>{vehicle.vin}</VinNumber>
                        </div>
                        <div className="ScheduleAppointmentSuccess__whatToBring">
                            {t("ContinueDeal.ScheduleAppointmentSuccess.bringYour")}
                            <ul className="ScheduleAppointmentSuccess__whatToBring--images">
                                <li className="ScheduleAppointmentSuccess__whatToBring--image">
                                    <img src={dlImage} alt="" />
                                    {t("ContinueDeal.ScheduleAppointmentSuccess.driverLicense")}
                                </li>
                                <li className="ScheduleAppointmentSuccess__whatToBring--image">
                                    <img src={insuranceImage} alt="" />
                                    {t("ContinueDeal.ScheduleAppointmentSuccess.carInsurance")}
                                </li>
                                {hasTradePending && tradePendingBalance === 0 && (
                                    <li className="ScheduleAppointmentSuccess__whatToBring--image">
                                        <img src={titleImage} alt="" />
                                        {t("ContinueDeal.ScheduleAppointmentSuccess.vehicleTitle")}
                                    </li>
                                )}
                            </ul>
                            <p>{t("ContinueDeal.ScheduleAppointmentSuccess.message", { model: vehicle.model })}</p>
                        </div>
                        <div className="ScheduleAppointmentSuccess__actions">
                            <ButtonBox title={t("ContinueDeal.ScheduleAppointmentSuccess.gotQuestions")}>
                                {/* <SecondaryButton>Start a Conversation</SecondaryButton> */}
                                <SecondaryLink target="_top" href={`tel:${phone}`}>
                                    {t("ContinueDeal.ScheduleAppointmentSuccess.giveUsACallButtonLabel")}
                                </SecondaryLink>
                            </ButtonBox>
                            <ButtonBox title={t("ContinueDeal.ScheduleAppointmentSuccess.readyToVisit")}>
                                <SecondaryLink
                                    href={`http://maps.google.com/maps?daddr=${fullAddress}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    {t("ContinueDeal.ScheduleAppointmentSuccess.getDirections")}
                                </SecondaryLink>
                            </ButtonBox>
                        </div>
                        <div className="ScheduleAppointmentSuccess__back">
                            <Link to="/continue-deal">
                                <ArrowLeft /> {t("ContinueDeal.ScheduleAppointmentSuccess.back")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ScheduleAppointmentSuccess);
